import { createSlice } from "@reduxjs/toolkit";
import { FetchUsers, UpdateUserStatus } from "./usersAction";


const initialState:any = {
  users: [],
  loading: false,
  pagination: {},
  selectedUser: {},
  showConfirmModal: false

};


const userCommonSlice = createSlice({
  name: 'userCommonSlice',
  initialState,
  reducers: {

    setSelectedUser: (state, { payload }) => {
      state.selectedUser = payload
    },
    setShowConfirmModal: (state) => {
      state.showConfirmModal = true
    },
    setHideConfirmModal: (state) => {
      state.showConfirmModal = false
    }
  },

});


const users = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    updateUserStatus: (state, { payload }) => {
      state.users = state.users.map((user: any) =>
        user._id === payload.id
          ? { ...user, isBlocked: payload.isBlocked }
          : user 
      );
      state.showConfirmModal = false
    }

  },
  extraReducers: (builder: any) => {
    builder
      .addCase(FetchUsers.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(FetchUsers.fulfilled, (state: any, { payload }: any) => {
        state.users = payload.data
        state.pagination = payload.pagination
        state.loading = false

      })
      .addCase(FetchUsers.rejected, (state: any, action: any) => {
        state.loading = false;
      })

  }
});

const userUpdateStatus = createSlice({
  name: 'userUpdateStatus',
  initialState,
  reducers: {

  },
  extraReducers: (builder: any) => {
    builder
      .addCase(UpdateUserStatus.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(UpdateUserStatus.fulfilled, (state: any, { payload }: any) => {
        state.selectedUser = payload.data
        state.loading = false

      })
      .addCase(UpdateUserStatus.rejected, (state: any, action: any) => {
        state.loading = false;
      })

  }
});



export const { setSelectedUser, setShowConfirmModal, setHideConfirmModal } = userCommonSlice.actions
export const { updateUserStatus } = users.actions

export const userCommonReducer = userCommonSlice.reducer
export const userReducer = users.reducer;
export const userUpdateStatusReducer = userUpdateStatus.reducer
